import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { apiUrl } from "../../config";

const ProductsImageList = ({ productImageData, onEdit, onDelete }) => {
  return (
    <Table striped bordered hover responsive className="align-middle text-center">
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Product ID</th>
          <th>Type</th>
          <th>Image</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {productImageData.length > 0 ? (
          productImageData.map((data, index) => (
            <tr key={data.id}>
              <td>{index + 1}</td>
              <td>{data.productId}</td>
              <td>{data.type}</td>
              <td>
                <img
                  src={`${apiUrl}/${data.imageUrl}`}
                  alt={data.type}
                  className="student-thumbnail"
                  style={{
                    objectFit: "contain",
                    height: "70px",
                    width: "70px",
                    border: "1px solid #ddd",
                  }}
                />
              </td>
              <td className="d-flex gap-2 justify-content-center">
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => onEdit(data)}
                  title="Edit"
                >
                  <Edit size={16} />
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => onDelete(data.id)}
                  title="Delete"
                >
                  <Trash size={16} />
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5} className="text-center">
              No product images found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default ProductsImageList;